/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatplaceholderwaiting2Inputs */

const en_chatplaceholderwaiting2 = /** @type {(inputs: Chatplaceholderwaiting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for reply…`)
};

const pt_chatplaceholderwaiting2 = /** @type {(inputs: Chatplaceholderwaiting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A aguardar resposta…`)
};

/**
* | output |
* | --- |
* | "Waiting for reply…" |
*
* @param {Chatplaceholderwaiting2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatplaceholderwaiting2 = /** @type {((inputs?: Chatplaceholderwaiting2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatplaceholderwaiting2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatplaceholderwaiting2(inputs)
	return pt_chatplaceholderwaiting2(inputs)
});
export { chatplaceholderwaiting2 as "chatPlaceholderWaiting" }